import type { GalleryModelsUrl } from 'shared/types/gallery/models'

/**
 * Combines existing sets with additional priority sets
 * Priority sets are added at the beginning in the order they are provided
 * @param sets - The existing sets array
 * @param prioritySets - Additional sets to add at the beginning (optional)
 * @returns Combined array of sets with priority sets first
 */
export const combineWithPrioritySets = (
  sets: GalleryModelsUrl.JSONObject[],
  ...prioritySets: (GalleryModelsUrl.JSONObject | undefined)[]
): GalleryModelsUrl.JSONObject[] => {
  const setsToAdd: GalleryModelsUrl.JSONObject[] = []

  for (const set of prioritySets) {
    if (set && Object.keys(set).length > 0) {
      setsToAdd.push(set)
    }
  }

  return [...setsToAdd, ...sets]
}
